import { useGetFlow } from "@/queries/flows/flows.api";
import { ExecutionCanvas } from "@/workflow_api/execution-canvas";
import { useUIStore } from "@/workflow_api/store/uiStore";
import { useWorkflowStore } from "@/workflow_api/store/workflowStore";
import { useEffect } from "react";
import { useParams } from "react-router";

const FlowExecution = () => {
  const params = useParams<{
    flowId: string;
  }>();
  const { data } = useGetFlow(params.flowId!);
  const { parseApiNodesToReactFlowNodes, reset, setFlowId } =
    useWorkflowStore();

  const {
    setFlowName,
    reset: resetUi,
    modalState: uimodal,
    setModalState: setUIModalState,
  } = useUIStore();

  useEffect(() => {
    const down = (e: KeyboardEvent) => {
      if (uimodal === "idle") {
        if ((e.ctrlKey || e.metaKey) && e.key === "f") {
          e.preventDefault();
          setUIModalState("search-nodes");
        }
      }
    };
    document.addEventListener("keydown", down);
    return () => {
      document.removeEventListener("keydown", down);
    };
  }, [uimodal, setUIModalState]);

  useEffect(() => {
    if (data) {
      if (data.data.nodes) {
        parseApiNodesToReactFlowNodes({
          nodes: data.data.nodes,
        });
      }
      setFlowName(data.data.name);
      setFlowId(data.data.id!);
    } else {
      reset();
      resetUi();
      setFlowName("");
      setFlowId("");
    }
    return () => {
      setFlowName("");
    };
  }, [
    data,
    setFlowName,
    resetUi,
    reset,
    parseApiNodesToReactFlowNodes,
    setFlowId,
  ]);
  return (
    <>
      <ExecutionCanvas />
    </>
  );
};

export default FlowExecution;
